angular.module('admin.directives')

.directive('datasourceViewerWithAddress', [function(){
  return {
    controllerAs: 'dataParentCtrl',
    bindToController: {
    },
    scope: {},
    restrict: 'E',
    templateUrl: '/admin/templates/partials/datasource-viewer-with-address.html',
    controller: function(){

    }
  }

}]);
